import { render, staticRenderFns } from "./AssociationList.vue?vue&type=template&id=7e568771&scoped=true"
import script from "./AssociationList.vue?vue&type=script&lang=js"
export * from "./AssociationList.vue?vue&type=script&lang=js"
import style0 from "./AssociationList.vue?vue&type=style&index=0&id=7e568771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e568771",
  null
  
)

export default component.exports